import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '../../../branding';
import './styles.less';
import Certificate from '../certificate';
import classNames from 'classnames';
import LearningItemActionButton from './LearningItemActionButton';
import { PaperIcon } from '@nackle/paper';
import { Translate } from '../../../services';
import { Link } from '..';

const LearningSearchResult = ( { dataAccessor, className, isLoading } ) => {
    const theme = useContext( ThemeContext );
    const classBase = 'learning-search-result';

    function getFooterContents() {
        let contents = [];

        const extensionReg = /\.(\w+)/;
        
        if ( dataAccessor?.filename?.match( extensionReg ) ) {
            contents.push( <span key='ft' className='filetype'>{ dataAccessor.filename.match( extensionReg )[ 1 ].toUpperCase() }</span> );
        }

        if ( dataAccessor?.tags?.length > 0 ) {
            contents.push( <span key='t' className='tags'>{ dataAccessor.tags.join( ', ' ) }</span> );
        }

        if ( contents.length > 1 ) {
            contents.splice( 1, 0, <span key='|'> | </span> );
        }

        return <>{ contents }</>;
    }

    return (
        <div className={ classNames( className, classBase, `${ classBase }-content`, 'tertiary', `${ classBase }-${ dataAccessor.__type }`, { locked: dataAccessor?.locked } ) } >
            { dataAccessor?.getThumbnail === undefined && dataAccessor.getIcon ?
                <div className={ `image-content ${ dataAccessor?.__type } icon` }>
                    { dataAccessor.getIcon() }
                    { dataAccessor?.prerequisiteData?.locked &&
                        <div className='overlay'><PaperIcon collection='ultimate' icon='Lock4' svgProps={ { width: '40px', height: '40px' } } /></div>
                    }
                </div>
                :
            theme !== 'seiko' ?
                <div className={ `image-content ${ dataAccessor?.__type }` }>
                    <img src={ dataAccessor?.getThumbnail( theme ) }/>
                    { dataAccessor?.prerequisiteData?.locked &&
                        <div className='overlay'><PaperIcon collection='ultimate' icon='Lock4' svgProps={ { width: '40px', height: '40px' } } /></div>
                    }
                </div>
                :
                <>
                    <img
                        src={ dataAccessor?.getThumbnail( theme ) }
                        className={ `${ classBase }-image` }
                        width="125"
                        height="65"
                        preserveAspectRatio="xMidYMid slice"
                    />
                    { dataAccessor?.prerequisiteData?.locked &&
                        <div className='overlay'><PaperIcon collection='ultimate' icon='Lock4' svgProps={ { width: '30px', height: '30px' } } /></div>
                    }
                </>
            }
            <div className={ `${ classBase }-details` }>

                <span className='locked-message'>
                    { dataAccessor?.prerequisiteData?.locked && dataAccessor?.prerequisiteData?.prerequisites &&
                        <>
                            <PaperIcon collection='ultimate' icon='Lock4' />
                            { 
                                dataAccessor.__type == 'course' && dataAccessor.prerequisiteData.operator == 'AND' ? <Translate.Text value='learningObject.locked.course.all'/> 
                                    : dataAccessor.__type == 'course' && dataAccessor.prerequisiteData.operator == 'OR' ? <Translate.Text value='learningObject.locked.course.any'/> 
                                    : dataAccessor.__type == 'curriculum' && dataAccessor.prerequisiteData.operator == 'AND' ? <Translate.Text value='learningObject.locked.curriculum.all'/> 
                                    : dataAccessor.__type == 'curriculum' && dataAccessor.prerequisiteData.operator == 'OR' ? <Translate.Text value='learningObject.locked.curriculum.any'/> : <></>
                            }
                            { dataAccessor.prerequisiteData.prerequisites
                                .filter( r => !r.completed )
                                .flatMap( ( req, i ) => ( [ ( i != 0 ? ',\u00A0' : '\u00A0' ), <Link key={ req.id } push to={ req.link }>{ req.name }</Link> ] ) ) }
                        </>
                    }
                </span>
                <span className='type subtitle'>{ dataAccessor?.type }</span>
                <p className='name'>{ dataAccessor?.displayName }</p>
                <p className='description'><span dangerouslySetInnerHTML={ { __html: dataAccessor?.description ?? '' } } /></p>
                <span className='footer subtitle'>
                    { getFooterContents() }
                </span>
            </div>
            
            { dataAccessor?.hasCertificate && !dataAccessor?.prerequisiteData?.locked && <Certificate isEarned={ dataAccessor.completed } fetchCertificateUrl={ dataAccessor.fetchCertificateUrl } /> }


            { dataAccessor?.prerequisiteData?.locked &&
                <span className="course-details-level-item-status-icon-container primary">
                    <PaperIcon collection='ultimate' icon='Lock4' />
                </span> 
            
            }

            <LearningItemActionButton dataAccessor={ dataAccessor } classBase={ classBase } isLoading={ isLoading } />

        </div> );
};

LearningSearchResult.propTypes = {
    dataAccessor: PropTypes.object,
    className: PropTypes.string,
    isLoading: PropTypes.bool,
};

LearningSearchResult.defaultProps = {
    isLoading: false,
    className: '',
    learningType: '',
    dataAccessor: null,
};

export default LearningSearchResult;